import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NavBar from '../NavBar/index.jsx';
import Footer from '../Footer/index.jsx';
import GetStarted from '../Home/SectionFive/index.jsx';

// Wrapper to use hook
function LayoutWrapper() {
	const location = useLocation();
	const isHome = location.pathname === '/' || location.pathname === '/home';

	return <LayoutComponent showGetStarted={!isHome} />;
}

export class LayoutComponent extends React.Component {
	render() {
		const { showGetStarted } = this.props;

		return (
			<section>
				<NavBar />
				<main>
					<Outlet />
				</main>
				{showGetStarted && (
					<section>
						<GetStarted />
					</section>
				)}
				<section className='footer-section-bottom'>
					<Footer />
				</section>
			</section>
		);
	}
}

export default LayoutWrapper;
